import { VALID_FILTER_FOR_SUMMARY } from "modules/category/constants/filter-constants";
import qs from "query-string";
import { getNextQuery } from "../url/getNextQuery";
import { URL_PARAM_ORDERS } from "../url/urlHelper";

export function getURLAfterClearAllClicked() {
  const { pathname, search } = window.location;
  const query = qs.parse(search);
  const queryObj = { ...query };
  Object.keys(queryObj).forEach((key) => {
    if (VALID_FILTER_FOR_SUMMARY.includes(key)) {
      delete queryObj[key];
    }
  });

  const queryString = qs.stringify(queryObj, {
    sort: (a: any, b: any) => URL_PARAM_ORDERS.indexOf(a) - URL_PARAM_ORDERS.indexOf(b),
  });
  const nextQuery = getNextQuery(queryString);
  return {
    href: nextQuery.length ? `${pathname}?${nextQuery}` : pathname,
    asPath: queryString.length ? `${pathname}?${queryString}` : pathname,
  };
}
